// Auth
export const LOGIN_USER_INFO = "LOGIN_USER_INFO";
export const SAVE_TOKEN = "SAVE_TOKEN";
export const FB_LOGIN_USER_INFO = "FB_LOGIN_USER_INFO";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const SAVE_CREDENTIALS = "SAVE_CREDENTIALS";
export const LAST_MODULE_CHECK = "LAST_MODULE_CHECK";